import { useMemo } from 'react';
import { Button, Row } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useResponsive } from "../../../../contexts";
import { useFeatureFlags } from "../../../../../hooks/useFeatureFlags";
import { getNextStepButtonText, getVendorGradientStyle } from "../../ClientOnboardingV2.utils";
import desktopStyles from "../../OnboardingPage/Steps/StepsContainer/StepsContainerDesktop.module.scss";
import mobileStyles from "../../OnboardingPage/Steps/StepsContainer/StepsContainerMobile.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export const GetFooterTID = parentTestId => getTestIds({
  parentTestId
});
export const Footer = _ref => {
  let {
    currentStep,
    relationship,
    onNext,
    testId
  } = _ref;
  const {
    MULTIPLE_LEGAL_TERMS_DOCUMENTS
  } = useFeatureFlags();
  const {
    isMobile
  } = useResponsive();
  const {
    FooterTestIds
  } = useMemo(() => GetFooterTID(testId), [testId]);
  const gradientStyle = getVendorGradientStyle(relationship.vendor.branding);
  const nextStepButtonText = getNextStepButtonText(currentStep, relationship, Boolean(MULTIPLE_LEGAL_TERMS_DOCUMENTS));
  const styles = isMobile ? mobileStyles : desktopStyles;
  return /*#__PURE__*/_jsx(Row, {
    className: styles.footer,
    style: gradientStyle,
    "data-testid": FooterTestIds.Root(),
    children: isMobile ? /*#__PURE__*/_jsx(Button, {
      onClick: onNext,
      className: styles.button,
      "data-testid": FooterTestIds.NextButton(),
      children: nextStepButtonText
    }) : /*#__PURE__*/_jsx(Row, {
      className: styles.footerContent,
      "data-testid": FooterTestIds.FooterContent(),
      children: /*#__PURE__*/_jsx(Button, {
        onClick: onNext,
        className: styles.button,
        "data-testid": FooterTestIds.NextButton(),
        children: nextStepButtonText
      })
    })
  });
};